// Contact deep-link helpers shared across pages.
// wa.me opens the WhatsApp app on mobile and the WhatsApp Web/Desktop prompt on
// PC; mailto:/tel: hand off to the OS default mail/phone apps.

export function normalizePhone(raw, defaultCountry = '91') {
  const digits = String(raw || '').replace(/\D+/g, '');
  if (!digits) return '';
  // Bare 10-digit numbers get the default country code (India).
  return digits.length === 10 ? `${defaultCountry}${digits}` : digits;
}

export function openWhatsApp(phone, message = '') {
  const p = normalizePhone(phone);
  if (!p) return false;
  const url = `https://wa.me/${p}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}

export function openEmail(email, subject = '', body = '') {
  const to = String(email || '').trim();
  if (!to) return false;
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);
  const q = params.toString();
  // location.href (not window.open) so no blank tab is left behind.
  window.location.href = `mailto:${to}${q ? `?${q}` : ''}`;
  return true;
}

export function openCall(phone) {
  const digits = String(phone || '').replace(/[^\d+]/g, '');
  if (!digits) return false;
  window.location.href = `tel:${digits}`;
  return true;
}

export function openCalendarEvent({ title = '', details = '', location = '' } = {}) {
  const params = new URLSearchParams({ action: 'TEMPLATE', text: title, details, location });
  window.open(`https://calendar.google.com/calendar/render?${params.toString()}`, '_blank', 'noopener,noreferrer');
  return true;
}
